import type { IInputQuestion } from './_question';
import type { InputProps } from '../Inputs/TextInput';

import React from 'react';
import { Controller } from 'react-hook-form';
import * as yup from 'yup';

import TextInput from '../Inputs/TextInput';

import InputWrapper from './elements/InputWrapper';
import Subtitle from './elements/Subtitle';
import Title from './elements/Title';

import theme from '$/assets/theme';
import getControlError from '$/hooks/getControlError';

export const yupTextInputQuestion = yup.string();

export interface ITextInputQuestion extends IInputQuestion, InputProps {
  onValueSelected?: () => void;
  successCheckmark?: boolean;
  errorInputName?: string;
}

const TextInputQuestion = ({
  control,
  name,
  onValueSelected,
  title,
  subTitle,
  successCheckmark = true,
  errorInputName,
  ...props
}: ITextInputQuestion) => (
  <>
    {title && <Title>{title}</Title>}
    {subTitle && <Subtitle>{subTitle}</Subtitle>}
    <InputWrapper>
      <Controller
        control={control}
        name={name}
        defaultValue={''}
        render={({ field, fieldState }) => {
          const error = getControlError(
            control,
            errorInputName ?? field.name,
            props.errorMessage
          );
          return (
            <TextInput
              {...field}
              value={field.value ?? ''}
              error={fieldState.invalid}
              containerProps={{
                style: {
                  borderColor: fieldState.invalid
                    ? theme.colors.functionalRed
                    : undefined,
                },
              }}
              success={
                !!(
                  (successCheckmark || props.successMessage) &&
                  fieldState.isDirty &&
                  !fieldState.invalid
                )
              }
              {...props}
              errorMessage={error.message}
            />
          );
        }}
      />
    </InputWrapper>
  </>
);

export default TextInputQuestion;
